import listPage from './view/listBanner.html';

export default {
  base: {
    state: 'declaration.corporateIncomeTax.smallBusinessGuidelines',
    config: {
      url: '/smallBusinessGuidelines',
      abstract: true,
      template: '<div ui-view></div>',
      default: 'declaration.corporateIncomeTax.smallBusinessGuidelines.list',
      title: '财务报表_小企业准则',
    },
  },
  list: {
    state: 'declaration.corporateIncomeTax.smallBusinessGuidelines.list',
    config: {
      url: '/list',
      template: listPage,
      controller: 'listBannerCtrl',
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/declaration/corporateIncomeTax/smallBusinessGuidelines/routers.js